import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getFormattedStartDate } from "functionCall";
import EngagementScheduleFilter from "modules/dashboards/engagement/EngagementScheduleFilter";
import { useExotelData, useExotelStats, useExotelStatsForPro } from "./store";
import ExotelData from "modules/callstats/ExotelData";
import DownloadData from "modules/callstats/DownloadData";
import CardTabs from "modules/common/card-tabs/CardTabs";
import ExotelStats from "modules/callstats/ExotelStats";
import { formatDate_ } from "modules/utilities/utility";

function CallStats() {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const sd = searchParams.get("sd");
  const ed = searchParams.get("ed");
  const [downloadData, setDownloadData] = useState("data");

  const { exotelData, isLoading, fetchExotelData } = useExotelData();
  const { fetchExotelStats, exotelStats } = useExotelStats();
  const { fetchExotelStatsForPro, exotelStatsForPro } = useExotelStatsForPro();

  const clearDate = () => {
    const formattedStartDate = getFormattedStartDate();
    setStartFilterDate(formattedStartDate);
    setEndFilterDate(formattedStartDate);
  };

  const [startFilterDate, setStartFilterDate] = useState(sd);
  const [endFilterDate, setEndFilterDate] = useState(ed);

  useEffect(() => {
    fetchExotelData(
      new Date(sd).toISOString().split("T")[0] + `T18:30:00.000Z`,
      new Date(ed).toISOString().split("T")[0] + `T18:29:59.999Z`
    );
    fetchExotelStats(
      new Date(sd).toISOString().split("T")[0] + `T18:30:00.000Z`,
      new Date(ed).toISOString().split("T")[0] + `T18:29:59.999Z`
    );
    fetchExotelStatsForPro(
      new Date(sd).toISOString().split("T")[0] + `T18:30:00.000Z`,
      new Date(ed).toISOString().split("T")[0] + `T18:29:59.999Z`
    );
    const formattedStartDate = formatDate_(startFilterDate, "start");
    const formattedEndDate = formatDate_(endFilterDate, "end");
    if (
      formattedStartDate !== formatDate_(sd, "start") ||
      formattedEndDate !== formatDate_(ed, "end")
    ) {
      const url = `/call-stats?sd=${formattedStartDate}&ed=${formattedEndDate}`;
      navigate(url);
    }
  }, [startFilterDate, endFilterDate, sd, ed, navigate]);

  

  return (
    <div>
      <div className="d-flex align-items-center gap-2 justify-content-end py-2">
        <DownloadData
          downloadData={downloadData}
          exotelData={exotelData}
          exotelStats={exotelStats}
        />
        <EngagementScheduleFilter
          setStartFilterDate={setStartFilterDate}
          setEndFilterDate={setEndFilterDate}
          clearDate={clearDate}
        />
      </div>
      <CardTabs
        components={{
          "exotel data": (
            <ExotelData
              exotel={exotelData}
              isLoading={isLoading}
              setDownloadData={setDownloadData}
            />
          ),
          "exotel stats": (
            <ExotelStats
              stats={exotelStats}
              proStats={exotelStatsForPro}
              setDownloadData={setDownloadData}
            />
          ),
        }}
      />
    </div>
  );
}

export default CallStats;
